export async function requestCameraPermission() {
  const stream = await navigator.mediaDevices.getUserMedia({ video: true });
  stream.getTracks().forEach((track) => track.stop());
}

export async function getCameraPermission(): Promise<PermissionState> {
  const browser = getBrowserBrand();

  if (browser === 'chrome' && navigator?.permissions) {
    const permissionObj = await navigator.permissions.query({
      name: 'camera',
    } as any);
    return permissionObj.state;
  }

  if (browser === 'firefox' || browser === 'safari') {
    const devices = await navigator.mediaDevices.enumerateDevices();
    const hasCamera = devices.some(
      (device) => device.kind === 'videoinput' && device.deviceId
    );
    return hasCamera ? 'granted' : 'prompt';
  }

  return 'denied';
}

export function getBrowserBrand() {
  const userAgent = navigator.userAgent;
  const browsers = {
    chrome: /chrome/i,
    safari: /safari/i,
    firefox: /firefox/i,
    ie: /internet explorer/i,
  };

  for (const key in browsers) {
    if ((browsers as any)[key].test(userAgent)) {
      return key;
    }
  }

  return 'unknown';
}

export function getCurrentOS() {
  const userAgent = navigator.userAgent;
  const os = {
    android: /android/i,
    ios: /iPad|iPhone|iPod/,
    windows: /windows/i,
    mac: /mac/i,
    linux: /linux/i,
  };

  for (const key in os) {
    if ((os as any)[key].test(userAgent)) {
      return key;
    }
  }

  return 'unknown';
}
